export const DEFAULT_TIMEOUT = 10000;

export function fetchWithTimeout(timeout = DEFAULT_TIMEOUT) {
  return async (url: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {
      return await fetch(url, {
        ...init,
        signal: controller.signal,
      });
    } finally {
      clearTimeout(id);
    }
  };
}